// LICENSE_CODE ZON
'use strict';

/*jslint browser:true, es6:true, node:true, react:true*/
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var set_parent_visible = item => {
  var parent = item.parent;
  if (!parent || parent && (parent.visible || parent.visible_menu)) return;
  parent.visible_menu = true;
  set_parent_visible(parent);
};
var item_matched = (item, q) => {
  return item.title && item.title.indexOf(q) != -1 || item.short && item.short.indexOf(q) != -1;
};
var convert_to_tree = (entries, q) => {
  var tree = [];
  var map = {};
  var deep = 2;
  var trees = [tree];
  var last_item = {};
  entries.forEach(item => {
    if (!item.tag) return;
    if (item.tag == `h${deep}`) trees[0].push(last_item = _objectSpread(_objectSpread({}, item), {}, {
      parent: last_item.parent
    }));else if (item.tag == `h${deep + 1}`) {
      deep++;
      trees.unshift(last_item.items = [last_item = _objectSpread(_objectSpread({}, item), {}, {
        parent: last_item
      })]);
    } else {
      var shift_count = deep - item.tag.substring(1);
      deep -= shift_count;
      while (shift_count) {
        trees.shift();
        shift_count--;
      }
      trees[0].push(last_item = _objectSpread(_objectSpread({}, item), {}, {
        parent: trees[0][0].parent
      }));
    }
    last_item.visible = !q || item_matched(item, q);
    if (last_item.visible) set_parent_visible(last_item);
    map[item.id] = last_item;
  });
  return {
    tree,
    map
  };
};
export { convert_to_tree };